export function latestThreeTaxYears() {
  const latest = new Date().getFullYear() - 1
  return [latest, latest - 1, latest - 2].map(String)
}

export function formatWon(value) {
  const n = Math.round(Number(value) || 0)
  return `${n.toLocaleString('ko-KR')}원`
}

export function formatTaxYearLabel(year) {
  const text = String(year ?? '').trim()
  if (!text) return ''
  return text.endsWith('년') ? text : `${text}년`
}

export function formatTaxYearLabels(years) {
  if (!Array.isArray(years)) return []
  return years.map(formatTaxYearLabel).filter(Boolean)
}

export function failedTaxYearLabels(yearStatuses, fallbackYears) {
  const failed = Array.isArray(yearStatuses)
    ? yearStatuses
      .filter((row) => String(row?.status || '').toUpperCase() !== 'SUCCESS')
      .map((row) => row?.year)
    : []
  return formatTaxYearLabels(failed.length > 0 ? failed : fallbackYears)
}

export function buildEstimatedClaimableBreakdown({ guide, filters, totals }) {
  const medicalTotal = Number(guide?.medicalTotal ?? totals?.medicalExpense) || 0
  const estimatedClaimable = Number(guide?.estimatedClaimable) || 0
  const glassesExcludedTotal = Number(guide?.glassesExcludedTotal) || 0
  const belowThresholdExcludedTotal = Number(guide?.belowThresholdExcludedTotal) || 0
  const deductibleReductionTotal = Number.isFinite(Number(guide?.deductibleReductionTotal))
    ? Number(guide.deductibleReductionTotal)
    : Math.max(0, medicalTotal - estimatedClaimable)
  const filterExcludedTotal = Number.isFinite(Number(guide?.filterExcludedTotal))
    ? Number(guide.filterExcludedTotal)
    : glassesExcludedTotal + belowThresholdExcludedTotal

  const lines = []
  if (filters?.excludeGlasses) {
    lines.push({ key: 'glasses', label: '안경·콘텍트렌즈 제외', amount: glassesExcludedTotal })
  }
  if (filters?.excludePharmacyBelowThreshold) {
    lines.push({ key: 'below-threshold', label: '청구기준 미달 제외', amount: belowThresholdExcludedTotal })
  }
  if (deductibleReductionTotal > 0) {
    lines.push({ key: 'deductible', label: '자기부담금·공제 차감', amount: deductibleReductionTotal })
  }

  const totalReduction = filterExcludedTotal + deductibleReductionTotal
  return { lines, totalReduction, medicalTotal, estimatedClaimable }
}
